module.exports = __webpack_public_path__ + "static/media/stars-less-750.bc355403.jpg";